module.exports = __webpack_public_path__ + "static/media/01.756dff37.mp3";